import { Flex } from 'antd';
import React from 'react';

import { WIDTH_CARD_TASK_MEDIUM } from '../const';
import { TaskBoardTaskAssignee } from '../taskBoard/component/taskBoardTaskAssignee';
import { TaskPositionType } from '../types';

interface ICalendarTaskBodyForthLine {
    task: TaskPositionType;
    widthTaskBody: number;
}

const CalendarTaskBodyForthLine: React.FC<ICalendarTaskBodyForthLine> = ({ task, widthTaskBody }) => {
    return (
        <>
            {(task.height >= 6 || (task.height === 5 && widthTaskBody > WIDTH_CARD_TASK_MEDIUM)) && (
                <Flex style={{ zIndex: 1000 }}>
                    <TaskBoardTaskAssignee userId={task.owner_task_id} />
                </Flex>
            )}
        </>
    );
};

export default CalendarTaskBodyForthLine;
